import gql from 'graphql-tag';

export default gql`
    query {
        getNetworkFees {
            currency
            fee
        }
    }
`;